// extracted by mini-css-extract-plugin
export default {"SetNewPasswordPage":"styles_SetNewPasswordPage__vp8K3","container":"styles_container__GrXOr"};